import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
/*App imports*/
import { HelpersService, TiposCreditos } from '../../../services/tools/helpers.service';
import { ReportesCarteraService } from '../../../services/reportes/reportes-cartera.service';
import { ReportsHelperService } from '../../../services/tools/reports-helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { SucursalesService } from '../../../services/sucursales.service';

@Component({
    selector: 'reporte-pagos',
    templateUrl: './cartera-creditos.component.html'
  })

export class CarteraCreditosComponent implements OnInit {
    //Report
    public reportData: any [] = [];
    public totales: any = {};
    public subtitle: string = null;
    //Filters
    public fechaInicio: string = null;
    public fechaFin: string = null;
    public tipoCreditoSelected: any = ''; 
    public tiposCreditos: any[] = [];
    public riesgos: number[] = [1,2,3,4,5,6,7,10];
    public riesgoSelected: any = ''; 
    //Helpers
    public isLoading: boolean = true;
    private sub: any;

    public sucursales: any[] = [];
    public sucursal: any = {id:null};
    public sucursalPorDefecto: string = "";

    constructor(
        private route: ActivatedRoute,
        private helperService: HelpersService,
        private reportesService: ReportesCarteraService,
        private creditosService: CreditosService,
        private sucursalesService : SucursalesService,
        public reportHelper: ReportsHelperService
    ){

    }

    public ngOnInit() {   
        this.sub = this.route.params.subscribe(params => {
            let credito = params['credito'];
            console.log('credito', credito);
            if(credito){
                this.setupComponent(credito);
            }
        });
        this.setupDefaultState();
        if(!this.tipoCreditoSelected){
            this.setupReporteGeneral();
        }
        ///Después de configurar el rango de fechas default y seleccionar el tipo de crédito, se actualiza la info del reporte
        this.getTiposCreditos();
        this.getSucursales();
    }

    private setupDefaultState() {
        let defaultDates = this.reportHelper.getDefaultDates();
        
        this.fechaInicio = defaultDates.fechaInicio;
        this.fechaFin = defaultDates.fechaFin;
    }

    private getSucursales(){
        this.isLoading = true;
        this.sucursalesService.get().subscribe(
          (response)=>
          {
            const jsonResult = response.json();
            if(jsonResult.content){
              this.sucursales = jsonResult.content.data;
              if (this.sucursales.length>1){
                this.sucursalPorDefecto = "Seleccione";
              } else if(this.sucursales.length>0){
                this.sucursal =  this.sucursales[0];
              }
              this.updateReporte();
              this.isLoading = false;
            }
            
          }, error =>
          {
            // se resuelve error 403 y 500
            this.isLoading = false;
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }
    
    sucursalChanged(sucursal){
        if(sucursal){
            this.sucursal = sucursal;
            this.updateReporte();
        }
    }

    private setupReporteGeneral(){
        this.subtitle = 'DETALLE DE CARTERA';
    }

    private setupComponent(tipoCredito: string){
        let infoCredito = this.reportHelper.getInfoTipoCredito(tipoCredito);
        this.subtitle = infoCredito.label;
        this.tipoCreditoSelected = infoCredito.id;
    }

    public onChangeTipoCredito(){
        this.setLabelTipoCredito(this.tipoCreditoSelected);
        this.updateReporte();
    }

    public updateReporte(){

        let filters = {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            tipoCredito: this.tipoCreditoSelected,
            riesgo: this.riesgoSelected,
            sucursal : this.sucursal.id
        }

        //Mostrar el ajax loading
        this.isLoading = true;

        this.reportesService.creditos(filters).subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                let items = [];
                let totales = {};
                if(jsonResult.content ){
                    if(jsonResult.content.items){
                        items = jsonResult.content.items;
                    }
                    if(jsonResult.content.totales){
                        totales = jsonResult.content.totales;
                    }
                }

                this.reportData = items;
                this.totales = totales;
                this.isLoading = false;
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    private getTiposCreditos(){
        this.creditosService.getTiposCreditos().subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                if(jsonResult.content){
                    this.tiposCreditos = jsonResult.content;
                }
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }

    private setLabelTipoCredito(tipoCredito: number){
        
        switch(tipoCredito){
            case TiposCreditos.Hipotecario:
                this.subtitle = 'HIPOTECARIO';
                break;
            case TiposCreditos.Automotriz:
                this.subtitle = 'AUTOMOTRIZ';
                break;
            case TiposCreditos.Prendario:
                this.subtitle = 'PRENDARIO';
                break;
            case TiposCreditos.Verde:
                this.subtitle = 'VERDE';
                break;
            case TiposCreditos.Personal:
                this.subtitle = 'PERSONAL';
                break;
            case TiposCreditos.Nomina:
                this.subtitle = 'NOMINA';
                break;
            case TiposCreditos.Carburacion:
                this.subtitle = 'CREDIGAS CARBURACION';
                break;
            case TiposCreditos.Estacionario:
                this.subtitle = 'CREDIGAS ESTACIONARIO';
                break;
            default:
                //Cuando se quita el filtro de tipo de crédito, se regresa a la vista de Detalle de cartera
                this.subtitle = 'DETALLE DE CARTERA';
                break;
        }
    }

    public print(){
        //Imprimir pantalla
        window.print();
    }

    public descargar() {

        let filters = {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            tipoCredito: this.tipoCreditoSelected,
            riesgo: this.riesgoSelected,
            sucursal : this.sucursal.id
        }

        this.reportesService.creditos(filters, true).subscribe(
            (response)=>
            {
                const fileUrl = window.URL.createObjectURL(response.blob());
                //Muestra el archivo en una nueva ventana
                window.open(fileUrl);
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/cartera/creditos/cartera-creditos.component.ts